import { render, staticRenderFns } from "./DeliveryCampaignImportsPage.vue?vue&type=template&id=9ef357b0&scoped=true"
import script from "./DeliveryCampaignImportsPage.vue?vue&type=script&lang=js"
export * from "./DeliveryCampaignImportsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef357b0",
  null
  
)

export default component.exports